(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function init(root) {
    if (!root || root.getAttribute("data-kcp-init") === "1") return;
    root.setAttribute("data-kcp-init", "1");

    /* Per-tab background colors (from product metafields, set in Liquid) */
    var bg1 = root.getAttribute("data-kcp-bg-1");
    var bg2 = root.getAttribute("data-kcp-bg-2");

    function applyBg(tabIndex) {
      var color = tabIndex === "2" ? bg2 : bg1;
      if (!color) return;
      root.style.setProperty("--kcp-bg", color);
      /* also recolor the outer .shopify-section wrapper so there is no edge mismatch */
      var wrapper = root.closest(".shopify-section");
      if (wrapper) wrapper.style.backgroundColor = color;
    }

    /* set the wrapper background on load to match the active tab */
    applyBg("1");

    /* ── Tabs ── */
    root.querySelectorAll("[data-kcp-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var t = tab.getAttribute("data-kcp-tab");

        root.querySelectorAll("[data-kcp-tab]").forEach(function (x) {
          var on = x === tab;
          x.classList.toggle("is-active", on);
          x.setAttribute("aria-selected", on ? "true" : "false");
        });
        root.querySelectorAll(".kcp__panel[data-kcp-panel]").forEach(function (p) {
          var match = p.getAttribute("data-kcp-panel") === t;
          p.classList.toggle("is-active", match);
          p.setAttribute("aria-hidden", match ? "false" : "true");
        });
        root.querySelectorAll("[data-kcp-gallery]").forEach(function (g) {
          var match = g.getAttribute("data-kcp-panel") === t;
          g.classList.toggle("is-active", match);
        });

        /* Swap background to the active product's color */
        applyBg(t);

        /* Update breadcrumb current label to the active tab */
        var crumb = root.querySelector("[data-kcp-crumb-current]");
        if (crumb) {
          var lbl = tab.textContent.trim();
          if (lbl) crumb.textContent = lbl;
        }
      });
    });

    /* ── Gallery thumbnails ── */
    root.querySelectorAll("[data-kcp-gallery]").forEach(function (gal) {
      var main = gal.querySelector("[data-kcp-main]");
      if (!main) return;
      gal.querySelectorAll(".kcp__thumb").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-full-src");
          if (src) main.setAttribute("src", src);
          gal.querySelectorAll(".kcp__thumb").forEach(function (b) {
            b.classList.remove("is-active");
          });
          thumb.classList.add("is-active");
        });
      });
    });

    /* ── Variant select → price ── */
    root.querySelectorAll("[data-kcp-variant-select]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        var price = opt.getAttribute("data-price");
        var panel = sel.closest(".kcp__panel");
        if (panel && price) {
          var prEl = panel.querySelector("[data-kcp-price]");
          if (prEl) prEl.textContent = price;
        }
      });
    });

    /* ── Quantity steppers ── */
    root.querySelectorAll("[data-kcp-qty-minus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var wrap = btn.closest("[data-kcp-qty]");
        var inp = wrap && wrap.querySelector('input[name="quantity"]');
        if (!inp) return;
        var v = Math.max(1, parseInt(inp.value, 10) || 1);
        inp.value = String(Math.max(1, v - 1));
      });
    });
    root.querySelectorAll("[data-kcp-qty-plus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var wrap = btn.closest("[data-kcp-qty]");
        var inp = wrap && wrap.querySelector('input[name="quantity"]');
        if (!inp) return;
        var max = parseInt(inp.getAttribute("max"), 10);
        var v = Math.max(1, parseInt(inp.value, 10) || 1);
        var next = v + 1;
        if (!isNaN(max) && max > 0) next = Math.min(next, max);
        inp.value = String(next);
      });
    });

    /* ── Accordions ── */
    root.querySelectorAll("[data-kcp-acc]").forEach(function (head) {
      head.addEventListener("click", function () {
        var expanded = head.getAttribute("aria-expanded") === "true";
        head.setAttribute("aria-expanded", expanded ? "false" : "true");
        var body = head.parentElement.querySelector("[data-kcp-acc-body]");
        if (body) body.hidden = expanded;
      });
    });

    /* ── Buy Now (add then checkout) ── */
    root.querySelectorAll("[data-kcp-buy-now]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var form = btn.closest("form");
        if (!form) return;
        var fd = new FormData(form);
        fetch("/cart/add.js", {
          method: "POST",
          body: fd,
          headers: { Accept: "application/json" },
        })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            window.location.href = "/checkout";
          })
          .catch(function () {
            form.submit();
          });
      });
    });
  }

  ready(function () {
    document.querySelectorAll("[data-kayu-collection-product]").forEach(init);
  });

  document.addEventListener("shopify:section:load", function (ev) {
    var sec =
      ev.target &&
      ev.target.querySelector &&
      ev.target.querySelector("[data-kayu-collection-product]");
    if (sec) {
      sec.removeAttribute("data-kcp-init");
      init(sec);
    }
  });
})();